export default __webpack_public_path__ + "static/Inter-Medium-8a50feca5194fae5cc45db842f63dc06.woff2";